module.exports = __webpack_public_path__ + "img/cr-fishing-prawns.cfd40cec.png";